module.exports = __webpack_public_path__ + "img/horizontal_4_3_pp3_8.bc06d747.png";